import React from 'react'
import { Grid } from '@mui/material'
import JobTextField from 'components/Drawers/JobDrawer/JobTextField'
import JobChipField from 'components/Drawers/JobDrawer/JobChipField'
import { stateOptions, areaOptions, AREA_ICONS } from 'components/Drawers/JobDrawer/constants'

const LocationSection = ({ values, setState, showError, setJobAlertData }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <JobTextField
          required
          label='City'
          name='city'
          value={values.city}
          setState={setState}
          showError={showError}
          setJobAlertData={setJobAlertData}
        />
      </Grid>
      <Grid item xs={6}>
        <JobTextField
          required
          label='State'
          name='state'
          value={values.state}
          options={stateOptions}
          setState={setState}
          showError={showError}
          setJobAlertData={setJobAlertData}
        />
      </Grid>
      <Grid item xs={12}>
        <JobChipField
          label='Area'
          name='area'
          options={areaOptions}
          icons={AREA_ICONS}
          value={values.area}
          setState={setState}
        />
      </Grid>
    </Grid>
  )
}

export default LocationSection
